// @ts-check
import React from "react"
import { CLOSE_TYPES } from "../../../../../consts/modules/clientReport.consts"
import Dropdown from "../../../../../components/atoms/Dropdown.atom"

const SPRINT_FILTER_OPTIONS = [
  { label: "Sprints", value: CLOSE_TYPES.NORMAL },
  { label: "Time outs", value: CLOSE_TYPES.TIMEOUT },
]

/** @param {import("../../../../../components/table/types/table").FilterElementOptions} options */
const SprintsFilter = (options) => {
  return (
    <>
      <Dropdown
        className="sprint-close-type-filter"
        value={options.value}
        options={SPRINT_FILTER_OPTIONS}
        onChange={(e) => {
          options.filterCallback(e.value)
        }}
        optionLabel="label"
        optionValue="value"
        placeholder="Filtrar sprint"
      />
    </>
  )
}

export function useClientSprintsTableFilters() {
  return {
    sprintTypeFilterTemplate: SprintsFilter,
  }
}
